<script>
	let showVideo = false;
  let audio;
  let volume = 100;

  $: if (audio) {
    audio.volume = volume / 100;
  }

  const onShowVideo = () => {
    showVideo = !showVideo;
    audio.play();
  }
</script>

<main>
  <div id="container">
    {#if !showVideo}
      <h2>Gratulálunk!</h2>
      <p>Sikeresen túlétetél egy nehéz hétvégét!</p>
      <button  id="showVideo" class="glow-on-hover" on:click={onShowVideo}>Vedd át elismerésed!</button>
    {:else}
    <video width="100%" autoplay loop >
      <source src="video.mp4" type="video/mp4"/>
    </video>
    {/if}
  </div>
</main>

{#if showVideo}
<div id="sliderContainer">
  <span id="volumeValue">{volume} %</span>
  <input bind:value={volume} type="range" min="0" max="100" class="volume" />
</div>
{/if}

<audio loop bind:this={audio} volume={volume / 100}>
  <source src="Audience64k-c.mp3" type="audio/mpeg"/>
  <track kind="captions">
</audio>


<style>
  @import url('https://fonts.googleapis.com/css2?family=Dancing+Script&family=M+PLUS+2:wght@200;300;400&display=swap');

main {
  background-image: url("/bg.jpg");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}

#container {
  width: 100%;
  max-width: 640px;
  height: 360px;
  background-color: rgba(160, 160, 160, 0.5);
  box-shadow: 0 0 17px 1px rgb(39 39 39);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 10px;
  text-align: center;
}

video {
  border-radius: 15px;
}

#showVideo {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
}

h2 {
  font-size: 6rem;
  font-family: 'Dancing Script', cursive;
  color: white;
  font-weight: 800;
}

p {
  font-family: 'M PLUS 2', sans-serif;
  margin-bottom: 3rem;
  margin-top: 0.5rem;
  color: white;
  font-size: 1.5em;
  text-transform: uppercase;
  font-weight: 300 !important;
}

button {
  font-family: 'M PLUS 2', sans-serif;
  text-transform: uppercase;
  font-weight: 300 !important;
  font-size: 1rem;
  letter-spacing: 2px;
}

#sliderContainer {
  position: fixed;
  bottom: 10px;
  right: 10px;
}

#volumeValue {
  position: relative;
  display: block;
  text-align: center;
  font-size: 2rem;
  color: #f7b55b;
  font-weight: 400;
}
.volume {
  width: 200px;
  height: 15px;
  -webkit-appearance: none;
  background: #111;
  outline: none;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 1);
}
.volume::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #f7b55b;
  cursor: pointer;
  border: 4px solid #333;
  box-shadow: -407px 0 0 400px #f7b55b;
}

.glow-on-hover {
    width: 300px;
    border: none;
    outline: none;
    color: #fff;
    background: rgb(17, 17, 17);
    cursor: pointer;
    position: relative;
    z-index: 0;
    border-radius: 10px;
    text-align: center;
}

.glow-on-hover:before {
    content: '';
    /*background: linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000);*/
    background: linear-gradient(45deg, #fbbf49, #fddf47, #c9b23d, #ffffff, #fbbf49, #c9b23d );
    position: absolute;
    top: -2px;
    left:-2px;
    background-size: 400%;
    z-index: -1;
    filter: blur(5px);
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    animation: glowing 20s linear infinite;
    opacity: 0;
    transition: opacity .3s ease-in-out;
    border-radius: 15px;
}

.glow-on-hover:active {
    color: #000
}

.glow-on-hover:active:after {
    background: transparent;
}

.glow-on-hover:hover:before {
    opacity: 1;
}

.glow-on-hover:after {
    z-index: -1;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: #111;
    left: 0;
    top: 0;
    border-radius: 10px;
}

@keyframes glowing {
    0% { background-position: 0 0; }
    50% { background-position: 400% 0; }
    100% { background-position: 0 0; }
}

</style>